﻿window.cObjetComSmsEnvoiMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetTableUpdateLib = function () { return ["com_sms_envoi"] }

    this.mGetLibBase = function () { return "sms envoyé"; }
    this.mGetAttributBase = function () { return "l'" }
    this.mGetNewLib = function () { return "Nouveau sms"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined') { txt = ((objet.data.body_txt) ? objet.data.body_txt : "") }
        else {
            txt = "sms"
        }
        if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        var $Icone = null
        var toolTip = "SMS envoyé"
        if (typeof dataTemplate == 'undefined') { $Icone = $("<i class='fas fa-comment-sms'></i>"); }
        else {
            $Icone = $("<i class='fas fa-comment-sms' style='position:relative'></i>");
            var $ssIcone = $("<i class='fas' style='position:absolute;bottom:-5px;right:-8px;opacity:1;font-size:65%;color:" + theme.backgroundcolorAccent + "'></i>")
            switch (parseInt(dataTemplate.id_type_classement)) {
                case 7: $ssIcone.addClass("fa-pen"); toolTip = "SMS brouillon"; break; //brouillon
                case 9: $ssIcone.addClass("fa-spinner fa-spin-pulse"); toolTip = "SMS en cours d'envoi"; break; //en cours d'envoi
                case 10: $ssIcone.addClass("fa-paper-plane"); toolTip = "SMS envoyé"; break; //envoi_envoye
                case 12: $ssIcone.addClass("fa-bullseye"); toolTip = "SMS tracké"; break; //tracking
            }
            if ($ssIcone) $ssIcone.appendTo($Icone)
        }
        $Icone.attr("title", toolTip)
        //$("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: $Icone, position: "bottom", contentTemplate: function (contentElement) { contentElement.text(toolTip) } })
        return $Icone
    }

    this.mGetNomFromTemplate = function (dataTemplate) {
        return ((typeof dataTemplate.objet != 'undefined' && dataTemplate.objet != null && dataTemplate.objet.length > 0) ? dataTemplate.objet : dataTemplate.body_txt)
    }
    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {
        if (typeof option == 'undefined') option = {}
        if (typeof option.hideStat == 'undefined') option.hideStat = false

        var $Table = $("<table style='table-layout:fixed;width:100%;text-align:left;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)

        var $TdObjetBody = $("<td style='width:75%;overflow:hidden;text-overflow:ellipsis;padding:0 3px;'/>").appendTo($Tr)

        var bodyTxt = $("<div/>").html(dataTemplate.body_txt).text().replace(/\u00A0/g, '')
        bodyTxt = bodyTxt.replace(/\|\$a\|/g, ''); //on enlève les séparateur d'hyperlien
        var txtNomObjet = ""
        if (dataTemplate.nom == null || dataTemplate.nom.length == 0) { }
        else { txtNomObjet += dataTemplate.nom.decoupe() }
        if (type == "Détails") {
            $TdObjetBody.html(txtNomObjet)
            $TdObjetBody.css("font-weight", "500")
            $TdObjetBody.attr("title", txtNomObjet)
        } else {
            bodyTxt = bodyTxt.substring(0, 300)
            var $B = $("<b style='font-weight:500;'/>").appendTo($TdObjetBody)
            $B.html(txtNomObjet)
            $("<span> &bull; <i style='opacity:0.7;'>" + bodyTxt + "</i></span>").appendTo($TdObjetBody)
        }

        var $TdEmailDestinataire = $("<td style='width:25%;overflow:hidden;text-overflow:ellipsis;padding:0 3px;font-size:90%;'></td>").appendTo($Tr)
        var txt = ""
        if (dataTemplate.adremails != null) {
            dataTemplate.adremails.split("|!*|").forEach(function (item, idx) {
                if (txt.length > 0) txt += " &bull; "
                txt += "<u>" + item + "</u>"
                if (dataTemplate.nomusuels.split("|!*|")[idx].length > 0) {
                    txt += " [" + dataTemplate.nomusuels.split("|!*|")[idx] + "]"
                }
            })

            if (dataTemplate.nbdest > 1) txt = "(" + dataTemplate.nbdest + ") " + txt
            if (dataTemplate.adremails.split("|!*|").length < dataTemplate.nbdest) txt += " ..."
        }
        $TdEmailDestinataire.html(txt)
        $TdEmailDestinataire.attr("title", "<b>Destinataire" + ((dataTemplate.nbdest > 1) ? "s" : "") + ":</b><br/>" + txt)

        var $TdDest = $("<td style='width:20px;padding:0 1px;height:1px;'/>").appendTo($Tr)
        switch (parseInt(dataTemplate.nbdest)) {
            case 0:
                $("<div style='width:18px;height:18px;border-radius:50%;' title='Aucun destinataire'/>").appendTo($TdDest).dxCtrlImgSimpleStrConUti({
                    bddCtrl: objet.bddRef,
                    icon1: "fas fa-at",
                    icon2: "",
                    text: ""
                })
                break;
            case 1:
                $("<div style='width:18px;height:18px;border-radius:50%;p' title='1 destinataire'/>").appendTo($TdDest).dxCtrlImgSimpleStrConUti({
                    bddCtrl: objet.bddRef,
                    icon1: ((dataTemplate.id_table_dest_envoi == null) ? "fas fa-at" : null),
                    idTable: dataTemplate.id_table_dest_envoi,
                    id: dataTemplate.id_dest_envoi,
                    text: dataTemplate.nom_usuel_envoi
                })
                break;
            default:
                $("<div style='width:18px;height:18px;border-radius:50%;' title='" + dataTemplate.nbdest + " destinataires'/>").appendTo($TdDest).dxCtrlImgSimpleStrConUti({
                    bddCtrl: objet.bddRef,
                    icon1: "fas fa-users",
                    icon2: "",
                    text: "",
                    count: dataTemplate.nbdest
                })
                break;
        }

        var $TdUti = $("<td style='width:20px;padding:0 1px;height:1px;'/>").appendTo($Tr)
        $("<div style='width:18px;height:18px;border-radius:50%;'/>").appendTo($TdUti).dxCtrlImgSimpleStrConUti({
            bddCtrl: objet.bddRef,
            idTable: objet.bddRef.getObjet("utilisateur").mGetTable().id_table,
            id: dataTemplate.id_utilisateur,
            text: objet.bddRef.getObjet("utilisateur", dataTemplate.id_utilisateur).mGetLib1()
        })

        if (type == "Détails") {
            if (dataTemplate.tracking == 1 && dataTemplate.date_envoi != null && !option.hideStat) {
                $TdReacGros = $("<td style='width:75px;padding-right:5px;height:1px;' rowspan='2'/>").appendTo($Tr)
                $("<div style='width:100%;height:100%;'/>").appendTo($TdReacGros).dxCtrlStatTaux({
                    bddCtrl: objet.bddRef,
                    dataTemplate: dataTemplate,
                    typeStat: "tx_reactivite_sms"
                })
            }

            var $Tr2 = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:100%;padding:0 3px;white-space:normal;font-style:italic;font-size:90%;line-height:1.3;opacity:0.7;' colspan='6'></td>").appendTo($Tr2)
            var $Div = $("<div class='ellipsismultiligne3'></div>").appendTo($Td)
            $Div.text(bodyTxt.decoupe())
        }


        //var $Table = $("<table style='table-layout:fixed;width:100%;text-align:left;'/>").appendTo(contentElement)
        //var $Tr = $("<tr/>").appendTo($Table)

        //var $TdUti = $("<td style='width:30px;padding:0 3px;height:1px;'/>").appendTo($Tr)
        //$("<div style='width:100%;height:100%;border-radius:50%;'/>").appendTo($TdUti).dxCtrlImgStrConUti({
        //    bddCtrl: objet.bddRef,
        //    idTable: objet.bddRef.getObjet("utilisateur").mGetTable().id_table,
        //    id: dataTemplate.id_utilisateur,
        //    text: objet.bddRef.getObjet("utilisateur", dataTemplate.id_utilisateur).mGetLib1()
        //})

        //var $TdDest = $("<td style='width:40px;padding:0 3px;height:1px;position:relative;'/>").appendTo($Tr)
        //switch (parseInt(dataTemplate.nbdest)) {
        //    case 0:
        //        $("<div style='width:35px;height:35px;border-radius:50%;position:absolute;bottom:-5px;' title='Aucun destinataire'/>").appendTo($TdDest).dxCtrlImgStrConUti({
        //            bddCtrl: objet.bddRef,
        //            icon1: "fas fa-mobile-screen-button",
        //            icon2: "",
        //            text: ""
        //        })
        //        break;
        //    case 1:
        //        $("<div style='width:35px;height:35px;border-radius:50%;position:absolute;bottom:-5px;' title='1 destinataire'/>").appendTo($TdDest).dxCtrlImgStrConUti({
        //            bddCtrl: objet.bddRef,
        //            icon1: "fas fa-mobile-screen-button",
        //            icon2: "",
        //            idTable: dataTemplate.id_table_dest_envoi,
        //            id: dataTemplate.id_dest_envoi,
        //            text: dataTemplate.nom_usuel_envoi
        //        })
        //        break;
        //    default:
        //        $("<div style='width:35px;height:35px;border-radius:50%;position:absolute;bottom:-5px;' title='" + dataTemplate.nbdest + " destinataires'/>").appendTo($TdDest).dxCtrlImgStrConUti({
        //            bddCtrl: objet.bddRef,
        //            icon1: "fas fa-users",
        //            icon2: "",
        //            text: "",
        //            count: dataTemplate.nbdest
        //        })
        //        break;
        //}

        //var $TdEmailDestinataire = $("<td style='width:25%;overflow:hidden;text-overflow:ellipsis;padding:0 3px;font-size:90%;'></td>").appendTo($Tr)
        //var txt = ""
        //if (dataTemplate.telmobs != null) {
        //    dataTemplate.telmobs.split("|!*|").forEach(function (item, idx) {
        //        if (txt.length > 0) txt += " &bull; "
        //        var tel = new cTelephone(null, item)
        //        txt += "<u>" + tel.mGetValueMiseEnForme() + "</u>"
        //        if (dataTemplate.nomusuels.split("|!*|")[idx].length > 0) {
        //            txt += " [" + dataTemplate.nomusuels.split("|!*|")[idx] + "]"
        //        }
        //    })
        //    if (dataTemplate.nbdest > 1) txt = "(" + dataTemplate.nbdest + ") " + txt
        //    if (dataTemplate.telmobs.split("|!*|").length < dataTemplate.nbdest) txt += " ..."
        //}
        //if (txt.length == 0) txt = "&nbsp;"
        //$TdEmailDestinataire.html(txt)
        //$TdEmailDestinataire.attr("title", "<b>Destinataire" + ((dataTemplate.nbdest > 1) ? "s" : "") + ":</b><br/>" + txt)

        //var $TdObjetBody = $("<td style='width:75%;overflow:hidden;text-overflow:ellipsis;padding:0 3px;'/>").appendTo($Tr)
        //var bodyTxt = ((dataTemplate.body_txt == null) ? "" : dataTemplate.body_txt.remplacerTout("|$a|", ""))
        //bodyTxt = $("<div/>").html(bodyTxt).text().replace(/\u00A0/g, '')
        //var txtNomObjet = ""
        //if (dataTemplate.nom == null || dataTemplate.nom.length == 0) { txtNomObjet += "&nbsp;" }
        //else { txtNomObjet += dataTemplate.nom.decoupe() }
        //if (type == "Détails") {
        //    $TdEmailDestinataire.css("width", "100%")
        //    $TdObjetBody.css("width", "0%")
        //    $TdObjetBody.html(txtNomObjet)
        //    $TdObjetBody.css("font-weight", "500")
        //    var $Tr2 = $("<tr/>").appendTo($Table)
        //    var $Td = $("<td style='width:100%;padding:0 3px;white-space:normal;font-style:italic;font-size:90%;line-height:1.3;opacity:0.7;padding-top:5px;' colspan='4'></td>").appendTo($Tr2)
        //    var $Div = $("<div class='ellipsismultiligne3'></div>").appendTo($Td)
        //    $Div.text(bodyTxt.decoupe())
        //} else {
        //    var $B = $("<b style='font-weight:500;'/>").appendTo($TdObjetBody)
        //    $B.html(txtNomObjet)
        //    bodyTxt = bodyTxt.substring(0, 300)
        //    $("<span style='opacity:0.7;'>" + bodyTxt + "</span>").appendTo($TdObjetBody)
        //}

    }
    this.itemTemplateGrillePlus = function (contentElement, dataPlus) {
        if (dataPlus.id_type_classement == "7") {
            //brouillon
            var $Span = $("<span style=''><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
            $Span.attr("title", "Créé le " + dataPlus.dcr.toFrenchDateTime())
        } else if (dataPlus.id_type_classement != "10" && dataPlus.id_type_classement != "12") {
            //envoi en cours
            var $Span = $("<span style=''><i class='fas fa-paper-plane dx-theme-accent-as-text-color' style='padding-right:3px;'></i><img src='" + parametre.urldispatch + "/img/jauge2.svg' style='width:12px;display:inline-block'/>en cours</span>").appendTo(contentElement)
            $Span.attr("title", "Envoi en cours")
        } else {
            //envoi fini
            var $Span = $("<span style=''><i class='fas fa-paper-plane dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.date_envoi.toDateIlya(true) + "</span>").appendTo(contentElement)
            $Span.attr("title", "Envoyé le " + dataPlus.date_envoi.toFrenchDateTime())
        }

        //$("<div/>").appendTo(contentElement).dxCtrlChartComEnvoiLigneResume({
        //    bddCtrl: objet.bddRef,
        //    dataPlus: dataPlus
        //})
        ////if (dataPlus.tracking == "1") {
        ////    if (dataPlus.nb_vue > 0 || dataPlus.nb_click > 0) {
        ////        if (dataPlus.nb_vue > 0) {
        ////            $("<span title='Nbre de vues%cr%(dernière vue le " + dataPlus.last_date_vue.toFrenchDateTime() + ")'><i class='fas fa-eye' title=''></i> (" + dataPlus.nb_vue + ") " + dataPlus.last_date_vue.toDateIlya(true) + "</span>").appendTo(contentElement)
        ////        }
        ////        if (dataPlus.nb_click > 0) {
        ////            if (dataPlus.nb_vue > 0) { $("<span> &bull; </span>").appendTo(contentElement) }
        ////            $("<span title='Nbre de clicks%cr%(dernier click le " + dataPlus.last_date_click.toFrenchDateTime() + ")'><i class='fas fa-arrow-pointer'></i> (" + dataPlus.nb_click + ") " + dataPlus.last_date_click.toDateIlya(true) + "</span>").appendTo(contentElement)
        ////        }
        ////        $("<span> &bull; </span>").appendTo(contentElement)
        ////    }
        ////}

        ////if (dataPlus.date_envoi == null) {
        ////    $("<span style='' title='" + dataPlus.dcr.toFrenchDateTime() + "'>Créé " + dataPlus.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
        ////} else {
        ////    $("<span style='' title='" + dataPlus.date_envoi.toFrenchDateTime() + "'>Envoyé " + dataPlus.date_envoi.toDateIlya(true) + "</span>").appendTo(contentElement)
        ////}
    }

    this.itemTemplateCard = function (contentElement) {
        var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:1px;vertical-align:top;'/>").appendTo($Tr)
        objet.mGetIcone().appendTo($Td)
        var $Td = $("<td style='width:100%'/>").appendTo($Tr)
        $Td.text(((objet.data.body_txt == null) ? "" : objet.data.body_txt.remplacerTout("|$a|", "")))
    }

    this.mSendImmediatement = function (funcOk) {
        objet.data.date_envoi = new Date()
        objet.data.id_type_classement = 13
        objet.mSave(function () {
            if (typeof funcOk != 'undefined') funcOk()
        })
    }

    this.mGetDateEtLib = function (court) {
        var fini = false
        switch (parseInt(objet.data.id_type_classement)) {
            case 7: txt = ((court) ? "" : "Créé ") + objet.data.dcr.toDateIlya(true) + ""; dat = "Créé le " + objet.data.dcr.toFrenchDateTime(); break; //brouillon
            case 8:
                if (diffdate(new Date(), objet.data.date_envoi) < 0) {
                    txt = ((court) ? "En crs envoi" : "En cours d'envoi");
                    dat = "En cours d'envoi"
                    fini = true
                } else {
                    txt = ((court) ? "" : "Sera envoyé dans ") + objet.data.date_envoi.toDateIlya(true, true) + "";
                    dat = "Sera envoyé le " + objet.data.date_envoi.toFrenchDateTime();
                }
                break; //envoi attente
            case 9: case 13:
                txt = ((court) ? "" : "EN COURS D'ENVOI"); dat = objet.data.date_envoi.toFrenchDateTime(); break; //envoi_en_cours OU envoi_attente_immédiat
            case 10: case 12:
                txt = ((court) ? "" : "Envoyé ") + objet.data.date_envoi.toDateIlya(true) + ""; dat = "Envoyé le " + objet.data.date_envoi.toFrenchDateTime(); break; //Envoyé //tracking
            case 11:
                txt = ((court) ? "" : "Essai d'envoi ") + objet.data.dcr.toDateIlya(true) + ""; dat = "Essai d'envoi le " + objet.data.dcr.toFrenchDateTime(); break; //erreur
        }
        return { dat: dat, lib: txt, fini: fini }
    }

    this.mShowNewSms = function (optionPopup) {
        var obj = Me.objet.bddRef.getObjet(Me.objet.bddRef.getObjet("com_sms_envoi").mGetNewData())
        obj.data.id_utilisateur = Me.objet.bddRef.utiCourant.id_utilisateur
        obj.data.id_type_classement = 7
        if (obj.data.emetteur.length == 0) obj.data.emetteur = Me.objet.bddRef.paraAppli.mGetPara("sms_emetteur")
        obj.mSave(function () {
            obj.mShowPopup()
        })
    }

    //this.mGetWidthPopup = function () { return 680 }
    this.mGetShowTitlePopup = function () { return false }

    this.isPopupFullScreen = true
    //this.mShowPopup = function (option) {
    //    if (typeof option == 'undefined') option = {}
    //    option.fullScreen = true
    //    page.mAddPopup(objet.data, option)
    //}
    this.contentTemplatePopup = function (contentElement, option) {
        contentElement.empty();
        //contentElement.css("padding", "0")
        contentElement.css("box-sizing", "border-box")
        dxCtrl = $("<div style='height:100%;width:100%;'/>").appendTo(contentElement).dxCtrlContentSmsEnvoi({
            bddCtrl: Me.objet.bddRef,
            data: objet.data,
            optionPopup: option
        }).dxCtrlContentSmsEnvoi("instance")
    }

    this.mCreateSmsBrouillon = function (bodyTxt, lstdest, mergeField, idMergeField, funcOk) {
        if (typeof mergeField == 'undefined' || mergeField == null) mergeField = false
        if (typeof idMergeField == "undefined") idMergeField = null //champ complementaire pour le merge (exemple: id_booking)
        Me.objet.bddRef.mAjaxCall({
            command: "createsmstemporairebrouillon",
            body_txt: bodyTxt,
            lstdest: lstdest,
            mergefield: ((mergeField) ? "1" : "0"),
            idmergefield: idMergeField
        }, function (data) {
            if (typeof funcOk != 'undefined') funcOk(data.id_com_sms_envoi)
        })
    }

    this.mSendImmediatement = function (funcOk) {
        objet.data.date_envoi = new Date()
        objet.data.id_type_classement = 13
        objet.mSave(function () {
            if (typeof funcOk != 'undefined') funcOk()
        })
    }

    this.mCreateComSms = function (lstdest, funcOk) {
        Me.objet.bddRef.mAjaxCall({
            command: "createcomsms",
            lstdest: lstdest
        }, function (data) {
            Me.objet.bddRef.triggerFunctionOnModifiedItemData("com_sms_envoi", "new", data.bddadd.com_sms_envoi[0])
            if (typeof funcOk != 'undefined') funcOk(data.id_com_sms_envoi)
        })
    }

    this.mSendSmsTest = function (codePays, telSms, nbCredit, jauge, funcOk) {
        //on duplik le sms
        var newDataSms = mCloneObjet(objet.data)
        newDataSms.jour_envoi = ""
        newDataSms.hors_jours_feries = "0"
        newDataSms.horaire_envoi = ""
        newDataSms.tempo_envoi_sec = 0
        newDataSms.tempo_envoi_nb_msg = 0
        newDataSms.pause_envoi = 0
        newDataSms.tracking = "0"
        newDataSms.id_com_sms_envoi = null
        objet.bddRef.getObjet(newDataSms).mSave(function (data) {
            var newDataComDest = objet.bddRef.getObjet("com_destinataire").mGetNewData()
            newDataComDest.id_type_destinataire = 1
            newDataComDest.id_table_com = objet.bddRef.table.mGetItemFromNom("com_sms_envoi").id_table
            newDataComDest.id_com = newDataSms.id_com_sms_envoi
            newDataComDest.id_table_destinataire = null
            newDataComDest.id_destinataire = null
            newDataComDest.tel_code_pays = codePays
            newDataComDest.tel_sms = telSms
            newDataComDest.nb_credit_par_message = nbCredit
            objet.bddRef.objCptCli.objetMetier.mUseSms(nbCredit)
            objet.bddRef.getObjet(newDataComDest).mSave(function (data) {
                newDataSms.date_envoi = parametre.dateNow
                newDataSms.id_type_classement = 9
                objet.bddRef.getObjet(newDataSms).mSave(function () {
                    //on attend que l'envoi soit fait pour supprimer le sms à la fin
                    mVerifTestEnvoiSms()

                    function mVerifTestEnvoiSms() {
                        var objComSmsEnvoi = objet.bddRef.getObjet("com_sms_envoi", newDataSms.id_com_sms_envoi)
                        if (typeof jauge != null && jauge.isCanceled) {
                            objComSmsEnvoi.mDelDataDefinitif()
                            mNotify("L'envoi de votre email de test a été annulé.", "warning", 6000)
                            funcOk()
                        } else {
                            if (objComSmsEnvoi.data.id_type_classement == 10) {
                                //le sms de test a été envoyé
                                objComSmsEnvoi.mDelDataDefinitif()
                                mNotify("Votre email de test a été envoyé.", "success", 6000)
                                funcOk()
                            } else {
                                //le sms est en attente d'envoi
                                window.setTimeout(function () { mVerifTestEnvoiSms() }, 1500)
                            }
                        }
                    }
                })
            })
        })
    }

    ////calcul crédit
    //this.nbCarBySmsString = 150
    //this.nbCarBySmsUnicode = 60
    //this.isUniCode = function () {
    //    var content = objet.data.body_txt
    //    if (content == null) content = ""
    //    for (var i = 0, n = content.length; i < n; i++) {
    //        if (content.charCodeAt(i) > 255) { return true; }
    //    }
    //    return false;
    //}

    //this.mGetMaxCar = function () {
    //    return this.mGetNbCarBySms() * 6
    //}
    //this.mGetNbCarBySms = function () {
    //    return ((this.isUniCode()) ? this.nbCarBySmsUnicode : this.nbCarBySmsString)
    //}

    //this.mGetNbCaractereMessage = function (withLienCourt) {
    //    if (typeof withLienCourt == 'undefined') withLienCourt = true
    //    var content = objet.data.body_txt
    //    var nbOccurenceLink = 0
    //    if (withLienCourt) {
    //        var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig
    //        var nbOccurenceLink = ((content.match(urlRegex) == null) ? 0 : content.match(urlRegex).length)
    //        content = content.replace(urlRegex, '')
    //    }
    //    return content.length + 60 * nbOccurenceLink
    //}
    //this.mGetNbCredit1MessageFrance = function (withLienCourt) {
    //    if (typeof withLienCourt == 'undefined') withLienCourt = true
    //    return Math.ceil(this.mGetNbCaractereMessage(withLienCourt) / this.mGetNbCarBySms())
    //}

    this.mGetCalculTotalCreditToUse = function (funcOk) {
        objet.bddRef.mAjaxCall({ command: "getlstdestcomfromcom", idtable: objet.bddRef.getObjet("com_sms_envoi").mGetTable().id_table, id: objet.data.id_com_sms_envoi },
            function (data) {
                data.lst = JSON.parse(data.lst)
                //if (typeof data.lst == "undefined") data.lst = []
                var nbTot = 0
                var sendSms = new cSendSms(objet.bddRef, objet.data.body_txt, option.data.ajout_stop == "1")
                data.lst.forEach(function (itemData) {
                    nbTot += sendSms.mGetNbCredit1Message(itemData.tel_code_pays, true)
                })
                if (typeof funcOk != 'undefined') funcOk(nbTot)
            })
    }

    this.mSaveNbCreditMessageComDestinataire = function (funcOk) {
        objet.bddRef.mAjaxCall({ command: "getlstdestcomfromcom", idtable: objet.bddRef.getObjet("com_sms_envoi").mGetTable().id_table, id: objet.data.id_com_sms_envoi },
            function (data) {
                //objet.bddRef.mAjaxCall({ command: "save_nb_credit_message", type: "email", nomtable: "lstdestcom", sql: "select * from com_destinataire where id_table_com=" + objet.bddRef.getObjet("com_sms_envoi").mGetTable().id_table + " and id_com=" + objet.data.id_com_sms_envoi + " " }, function (data) {
                data.lst = JSON.parse(data.lst)
                //if (typeof data.lst == "undefined") data.lst = []
                var sendSms = new cSendSms(objet.bddRef, objet.data.body_txt, objet.data.ajout_stop == "1")
                data.lst.forEach(function (itemData) {
                    objet.bddRef.getObjet(itemData).data.nb_credit_par_message = sendSms.mGetNbCredit1Message(itemData.tel_code_pays, true)
                })
                var lstNb = Me.mGetRepartCreditParCodePays(data.lst)
                objet.bddRef.mAjaxCall({ command: "save_nb_credit_message", type: "sms", data: lstNb }, function (data) {
                    if (typeof funcOk != 'undefined') funcOk()
                })
                //})
            })
    }

    this.mGetRepartCreditParCodePays = function (lstComDest) {
        var lstNb = []
        lstComDest.forEach(function (itemData) {
            var itemNb = lstNb.filter(function (o) { return o.code_pays == itemData.tel_code_pays })[0]
            if (typeof itemNb == 'undefined') {
                itemNb = {
                    code_pays: itemData.tel_code_pays,
                    nb_credit: itemData.nb_credit_par_message,
                    lstComDest: []
                }
                lstNb.push(itemNb)
            }
            itemNb.lstComDest.push(itemData)
        })
        return lstNb
    }

    this.mGetTotalCreditsToUse = function (funcOk) {
        objet.bddRef.mAjaxCall({ command: "getlstdestcomfromcom", idtable: objet.bddRef.getObjet("com_sms_envoi").mGetTable().id_table, id: objet.data.id_com_sms_envoi },
            function (data) {
                data.lst = JSON.parse(data.lst)
                //if (typeof data.lst == "undefined") data.lst = []
                var nbCredit = 0
                data.lst.forEach(function (itemData) {
                    nbCredit += parseInt(itemData.nb_credit_par_message)
                })
                funcOk(nbCredit)
            })
    }

    this.mSend = function (funcOk) {
        this.mSaveNbCreditMessageComDestinataire(function () {
            //on envoi le message
            if (objet.data.date_debut_envoi != null) { objet.data.date_envoi = objet.data.date_debut_envoi }
            else { objet.data.date_envoi = new Date(parametre.dateNow.getTime()) }
            //var dateEnvoi = new Date(parametre.dateNow.getTime())
            //option.data.date_envoi = dateEnvoi
            objet.data.id_type_classement = 9
            objet.data.nb_dest_envoye = 0
            Me.mGetTotalCreditsToUse(function (nbCreditTot) {
                objet.bddRef.objCptCli.objetMetier.mUseSms(nbCreditTot)
                objet.mSave(function () {
                    $(document).trigger('sendedSmsEvent', null);
                    if (typeof funcOk != 'undefined') funcOk()
                })
            })
        })
    }

    //this.mGetDivTarifSmsParPays = function (contentElement) {
    //    var $Div = $("<div style='width:100%;white-space:normal;height:100%;'/>")
    //    var $DivEntete = $("<div/>").appendTo($Div)
    //    $("<div style='font-size:200%;line-height:1;'>Nbre de crédits<br/>par SMS par pays</div>").appendTo($DivEntete)
    //    $("<div style='font-size:100%;padding-top:5px;'>Pour la France métropolitaine<br/>1 SMS = 1 crédit</div>").appendTo($DivEntete)
    //    $("<hr style='opacity:0.3'/>").appendTo($DivEntete)
    //    if (typeof contentElement != 'undefined') $Div.appendTo(contentElement)
    //    var dxScroll = $("<div style='white-space:normal;height:calc(100% - " + ($DivEntete.innerHeight() + 0) + "px);'/>").appendTo($Div).dxScrollView({}).dxScrollView("instance")
    //    var $Table = $("<table style='width:100%'/>").appendTo(dxScroll.content())
    //    var indicFrance = parametre.lstIndicatifTel.filter(function (o) { return o.code == "fr" })[0]
    //    var $Tr = $("<tr style='opacity:0.3'/>").appendTo($Table)
    //    var $Td = $("<td style='width:1px;'></td > ").appendTo($Tr)
    //    var $Td = $("<td style='text-align:left;width:100%;'>Pays</td > ").appendTo($Tr)
    //    var $Td = $("<td style='width:1px;'>crédit/SMS</td>").appendTo($Tr)
    //    parametre.lstIndicatifTel.sort(function (o1, o2) { return (o1.name).localeCompare(o2.name) }).forEach(function (indic) {
    //        var $Tr = $("<tr style='opacity:0.7'/>").appendTo($Table)
    //        if (indic.code == "fr") {
    //            $Tr.css({ "font-weight": "bold", "font-size": "150%", "opacity": "1" })
    //            $Tr.addClass("blinkscalealways")
    //        }
    //        var $Td = $("<td style='width:1px;'><img src='https://flagcdn.com/w20/" + indic.code.toLowerCase() + ".png' style='padding-right:5px;padding-top:5px;'/></td > ").appendTo($Tr)
    //        var $Td = $("<td style='text-align:left;width:100%;'>" + indic.name + "</td > ").appendTo($Tr)
    //        var nbCredit = parseInt((1 / indicFrance.price) * indic.price * 100) / 100
    //        var $Td = $("<td style='width:1px;'>" + nbCredit.formatDisplay(2) + "</td>").appendTo($Tr)
    //    })
    //    return $Div
    //}
}